export const environment = {
  production: true,
  env: 'dev',
  eventYtdInPersonTooltip: 'Events conducted live at a physical location',
  eventYtdVirtualTooltip: 'Events conducted remotely/virtually',
  eventYtdHybridTooltip: 'Events conducted both in-person and virtually',
  serverUrl: 'https://api.p2p.dev.zsservices.com/',
  loginUrl: 'https://idm.qa.zsservices.com/RWDI/IdentityManager/app/Web/login.aspx',
  logoutUrl: 'https://idm.qa.zsservices.com/RWDI/IdentityManager/app/Web/logout.aspx',
  idmAccountUrl: 'https://idm.qa.zsservices.com/RWDI/IdentityManager/app/web/MyAccount.aspx',
};
